import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PurchaseOrderDetailsContext, PurchaseOrderDetailsValues } from '../../contexts/PurchaseOrderDetailsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const PurchaseOrderDetailsConfirmModal = () => {
  const { isProcessing, isConfirmOpen, closeConfirmModal, confirmModal } = useContext(PurchaseOrderDetailsContext) as PurchaseOrderDetailsValues;
  const { t } = useTranslation('purchaseOrderDetails');

  return (
    <Dialog onClose={closeConfirmModal}
      open={isConfirmOpen}>
      <DialogTitle>
        {t('confirmModal.title')}
      </DialogTitle>
      <IconButton
        onClick={closeConfirmModal}
        disabled={isProcessing}
        sx={{
          position: 'absolute',
          right: 16,
          top: 8,
          color: (theme) => theme.palette.custom.gray[800],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Typography>
          {t('confirmModal.body')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ m: 4 }}>
        <Button variant='secondary'
          size="lg"
          disabled={isProcessing}
          onClick={closeConfirmModal}>
          {t('confirmModal.cancel')}
        </Button>
        <Button variant='primary'
          size="lg"
          disabled={isProcessing}
          onClick={confirmModal}>
          {t('confirmModal.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};